<template>
  <v-container fluid class="custom-section pa-0">
    <v-container class="text-center max-1618 pa-0">
      <v-row>
        <v-col>
          <h2 v-html="title" />
        </v-col>
      </v-row>
      <v-row class="padding-big kunde-row">
        <div class="kunde">
           <img
            eager
            src="/images/aktualisierung/AMF_Logo_quadrat.png"
            class="ma-auto custom-image"
            max-width="177"
            />
        </div>
        <div class="kunde">
           <img
            eager
            src="/images/aktualisierung/arbonia.png"
            class="ma-auto custom-image"
            max-width="177"
            />
        </div>
        <div class="kunde">
           <img
            eager
            src="/images/aktualisierung/BayernInternational.png"
            class="ma-auto custom-image"
            max-width="177"
            />
        </div>
        <div class="kunde">
           <img
            eager
            src="/images/aktualisierung/biokreis.png"
            class="ma-auto custom-image"
            max-width="177"
            />
          </div>
        <div class="kunde">
           <img
            eager
            src="/images/aktualisierung/Bistum_Passau.png"
            class="ma-auto custom-image"
            max-width="177"
            />
        </div>
        <div class="kunde">
           <img
            eager
            src="/images/aktualisierung/bmw_group.png"
            class="ma-auto custom-image"
            max-width="177"
            />
        </div>
        <div class="kunde">
           <img
            src="/images/aktualisierung/EW_Logo.png"
            class="ma-auto custom-image"
            width="177"
            />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/GOLDSTEIG.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/Graf_Arco.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/ilzerland.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/MMK-Passau.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/NPBW.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/RS.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/SACHS.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/SCU.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/sparkasse.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/sws-computersysteme.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/vhs.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/weigerstorfer.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/zambelli.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
        <div class="kunde">
           <img src="/images/aktualisierung/zwiesel_kristallglas.png"
           class="ma-auto custom-image"
           width="177"
           />
        </div>
      </v-row>
      <v-row>
        <v-col>
          <h2 class="viele-mehr">
            <span>
              <div class="d-flex dotdotdot">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </div>
              <p class="text">UND VIELE <strong>MEHR</strong></p>
            </span></h2>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>
<script>
export default {
  props: {
    title: String,
    class: String,
    background: {
      String,
      default: 'bg-white',
    },
  },
};
</script>

<style lang="scss">
  .kunde-row {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .dotdotdot {
  justify-content: space-between;
  margin: 0 auto .15em auto;
  max-width: 40px;
  position: relative;
  bottom: 1.5rem;
}

  .dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: red;

}

  .kunde {
    display: flex;
    flex: 1 0 13%;
    max-width: 100%;
    margin-top: 3.158rem;

    img {
      max-width: 177px;
    }
  }

  .first-section {
    margin-top: 100vh;
  }

  .max-1618 {
    max-width: 1618px;
    margin: 0 auto;
  }

  .custom-section {
    position: relative;
    z-index: 9;
  }

  .bg-grey {
    background-color: #F4F4F4;
  }

  .bg-white {
    background-color: #fff;
  }

  .section-content {
    font-weight: 300;
    line-height: 1.23;
    letter-spacing: .22px;
    color: #243236;

    strong {
      font-weight: 700;
    }
  }

  .padding-big {
    padding-bottom: 4.25rem;
  }

  .v-responsive {
    &.custom-image {
      max-width: 300px;
    }
  }

  h2 {
    line-height: .25 !important;
    text-align: center;

    .text {
    font-family: "museo-sans", sans-serif;
    color: #243236;
    font-size: 1.316rem;

    strong {
      font-weight: 900;
      }
    }

    > span {
      display: inline-block;
      position: relative;

     &::before,
     &::after {
        content: "";
        position: absolute;
        height: 5px;
        border-bottom: 1px solid black;
        top: 1.5rem;
        width: calc( (80vw - 300px) / 2) ;
      }

      &::before {
        right: 100%;
        margin-right: 1em;
      }
      &::after {
        left: 100%;
        margin-left: 1em;
      }
    }
  }

  @media screen and (max-width: 960px) {
  h2 > span::after, h2 > span::before {
    width: 60%;
  }
    .first-section {
      margin-top: 0vh;
    }

  .v-responsive {
    &.custom-image {
      max-width: 250px;
    }
  }
  }

  @media screen and (max-height: 765px) {
    .first-section {
      margin-top: 0vh;
    }
  }

  @media screen and (max-width: 512px) {
    .v-responsive {
      &.custom-image {
        max-width: 200px;
      }
    }
      h2 > span::after, h2 > span::before {
      width: 20%;
    }
  }
</style>
